import { CyclingEvent } from './types';
import { nextPriceChangeLabel } from './priceTiers';

/**
 * Die Glocke neben dem Anmeldestand (Trello MSryhIMb): „sag mir Bescheid, wenn die Anmeldung
 * öffnet oder der Preis steigt". Ein Klick merkt das Event vor und schaltet die
 * Anmeldungs-Nachricht ein (`POST /events/{id}/registration-alert`). Texte und Regeln stehen
 * hier einmal für Web und App.
 */

/** Zeigt die Seite die Glocke? Das Backend sagt, ob noch eine Nachricht kommen kann. */
export function showsRegistrationAlert(event: Pick<CyclingEvent, 'registrationNoticeAvailable'>): boolean {
  return !!event.registrationNoticeAvailable;
}

export const REGISTRATION_ALERT_LABEL = 'Benachrichtigen';
export const REGISTRATION_ALERT_ACTIVE_LABEL = 'Benachrichtigung an';
export const REGISTRATION_ALERT_TITLE = 'Wir sagen dir Bescheid';

/**
 * Wann die Mail kommt. Die Glocke steht nur, solange die Anmeldung nicht offen ist
 * (`registrationNoticeAvailable`); ist eine Preisstufe gepflegt, kommt der Preis dazu.
 */
export function registrationAlertPromise(
  event: Pick<CyclingEvent, 'priceTiers'>,
  now: Date = new Date()
): string {
  return nextPriceChangeLabel(event.priceTiers, now) !== null
    ? 'Wir schicken dir eine E-Mail, wenn die Anmeldung öffnet, und fünf Tage, bevor der Preis steigt.'
    : 'Wir schicken dir eine E-Mail, sobald die Anmeldung öffnet.';
}

/** Darunter, kleiner: was dabei sonst passiert. */
export const REGISTRATION_ALERT_FINE_PRINT =
  'Das Event landet dabei auf deiner Merkliste. Abbestellen kannst du die Nachricht in jeder Mail.';

/**
 * Ausgebucht: dieselbe Glocke, aber fürs nächste Jahr. Beim Vorrücken bekommen alle, die das
 * Event vorgemerkt haben, die Mail „nächste Auflage" und danach wieder die Anmeldungs-Nachricht.
 */
export const NEXT_EDITION_ALERT_LABEL = 'Fürs nächste Jahr benachrichtigen';
export const NEXT_EDITION_ALERT_PROMISE =
  'Das Event ist ausgebucht. Wir schicken dir eine E-Mail, sobald die Anmeldung fürs nächste Jahr öffnet.';

/** Ausgebucht und nicht abgesagt: dann führt der Hauptknopf zur Benachrichtigung fürs nächste Jahr. */
export function showsNextEditionAlert(event: Pick<CyclingEvent, 'fullyBooked' | 'cancelled' | 'permanent'>): boolean {
  return !!event.fullyBooked && !event.cancelled && !event.permanent;
}

export const REGISTRATION_ALERT_CONFIRMED = 'Wir benachrichtigen dich, sobald es Neuigkeiten zum Event gibt.';
